import ds, { dsc } from '../utils/daoService/DaoServiceClientES6Adapter'
import request from "@/utils/request";

const ebOrder = ds.QEbOrder.using(dsc)
const eiOrder = ds.QEiOrder.using(dsc)
const sysCorpCust = ds.QSysCorpCust.using(dsc)
const mdCodeDict = ds.QMdCodeDict.using(dsc)

// 用户查询
ebOrder.searchUser = function (data) {
  return request({
    url: '/web/queryMainSystem/queryUser',
    method: 'post',
    data: data
  })

}
// 发票查询
export function queryInvoice(searchData) {
  return request({
    url: '/web/queryMainSystem/queryInvoice',
    method: 'post',
    data: searchData
  })
}
// 修改历史查询
ebOrder.queryReviseHistoryEbOrder = function (searchData) {
  return request({
    url: '/web/queryMainSystem/queryEiOrderAndEbOrder',
    //url: '/web/queryMainSystem/queryEiOrderAndEbOrder',
    method: 'post',
    data: searchData
  })

}



// 简单查询+订单状态
ebOrder.queryEbOrder = function (searchData) {
    return request({
        url: '/web/billEdit/getBooking',
        method: 'post',
        data: searchData
    });
}
// 多条件
ebOrder.queryEbOrderMore = function (searchData) {
    return ebOrder
        .select(ebOrder.fieldContainer())
        .where(ebOrder.orderNo.in$(searchData.arrayNo)
            .or(ebOrder.custBizNo.in$(searchData.arrayNo))
            .or(ebOrder.mblNo.in$(searchData.arrayNo))
            .and(ebOrder.orderStatus._like$_(searchData.orderStatus))
            .and(ebOrder.transferStatus.ne$(1)))
        .paging(searchData.page, searchData.limit)
        .sorting(ebOrder.createTime.desc())
        .tag('queryEbOrder')
        .execute(searchData)
}

ebOrder.queryEbOrderMore1 = function (searchData) {
  return ebOrder
    .select(ebOrder.fieldContainer())
    .where(ebOrder.orderNo._like$_(searchData.arrayNo)
      .or(ebOrder.custBizNo._like$_(searchData.arrayNo))
      .or(ebOrder.mblNo.like$_(searchData.arrayNo))
      .and(ebOrder.orderStatus._like$_(searchData.orderStatus))
      .and(ebOrder.transferStatus.ne$(1)))
    .paging(searchData.page, searchData.limit)
    .sorting(ebOrder.createTime.desc())
    .tag('queryEbOrder')
    .execute(searchData)
}

// 高级查询+订单状态
ebOrder.queryMoreEbOrder = function (searchData) {
    return ebOrder
        .select(ebOrder.fieldContainer())
        .where(searchData.whereObj)
        .paging(searchData.page, searchData.limit)
        .sorting(ebOrder.createTime.desc())
        .tag('queryMoreEbOrder')
        .execute(searchData.valueObj)
}

// ebOrder.queryMoreEbOrder = function (searchData) {
//   return ebOrder
//     .select(ebOrder.fieldContainer())
//     .where(ebOrder.carrierName._like$_(searchData.carrierName)
//       .and(ebOrder.vesselNameEn._like$_(searchData.vesselName))
//       .and(ebOrder.voyage._like$_(searchData.voyage))
//       .and(ebOrder.createTime.between$(searchData.startTime, searchData.endTime))
//       .and(ebOrder.polName._like$_(searchData.polName))
//       .and(ebOrder.podName._like$_(searchData.podName))
//       .and(ebOrder.orderStatus._like$_(searchData.orderStatus))
//       .and(ebOrder.transferStatus.ne$(1)))
//     .paging(searchData.page, searchData.limit)
//     .tag('queryMoreEbOrder')
//     .execute(searchData)
// }

//查询最近使用的舱位公司
ebOrder.getLastCust = async function () {
    return await ds.otherClient.customization("getLastCustFromEbOrder")
        .select().execute()
}

//导出excel-简单查询
ebOrder.exportExcel = function (no) {
    ds.otherClient.withModel(ebOrder)
        .forExport(ebOrder.fieldContainer())
        .where(ebOrder.orderStatus.eq$("SUB")
            .and(ebOrder.mblNo.notNull()
                .or(ebOrder.orderNo.eq$(no))
                .or(ebOrder.mblNo.eq$(no))))
        .async(false).tag('EbOrderVGMExport').execute(this.callable)
}

//导出excel-高级查询
ebOrder.exportMoreExcel = function (searchData) {
    ds.otherClient.withModel(ebOrder)
        .forExport(ebOrder.fieldContainer())
        .where(ebOrder.orderStatus.eq$("SUB")
            .and(ebOrder.mblNo.notNull())
            .and(ebOrder.carrierName._like$_(searchData.carrierName))
            .and(ebOrder.vesselNameEn._like$_(searchData.vesselName))
            .and(ebOrder.voyage._like$_(searchData.voyage))
            .and(ebOrder.createTime.between$(searchData.startTime, searchData.endTime))
            .and(ebOrder.polName._like$_(searchData.polName))
            .and(ebOrder.podName._like$_(searchData.podName))
            .and(ebOrder.orderStatus._like$_(searchData.orderStatus)))
        .async(false).tag('EbOrderVGMExport').execute(this.callable)
}

//改配历史查询
ebOrder.queryEbOrderByTransferStatus = function (searchData) {
    return ebOrder
        .select(ebOrder.fieldContainer())
        .where(ebOrder.ebOrderId.eq$(searchData.ebOrderId)
            .and(ebOrder.transferStatus.eq$(searchData.transferStatus)))
        .paging(searchData.page, searchData.limit)
        .tag('queryEbOrderByTransferStatus')
        .execute(searchData)
}

//状态历史查询
export function getSpOrder(data) {
    return request({
        url: '/web/spOrder/getSpOrder',
        method: 'post',
        data
    })
}

// 多条件
export function getEbOrder(searchData) {
    return ebOrder.select(ebOrder.fieldContainer()).where(
        ebOrder.orderNo.eq$(searchData.arrayNo)
            .or(ebOrder.custBizNo.eq$(searchData.arrayNo))
            .or(ebOrder.mblNo.eq$(searchData.arrayNo))
    )
        .tag('getEbOrder')
        .execute(searchData)
}

export function getEbOrderByGoOrderId(goOrderId) {
  return ebOrder.select(ebOrder.fieldContainer()).where(
    ebOrder.goOrderId.eq$(goOrderId))
    .tag('getEbOrder')
    .execute()
}

export default ebOrder
